import { Loading } from '@fides/fides-react-components';
import React, { Suspense } from 'react';

const PageNotFound = React.lazy(() => import('../../components/pages/PageNotFound'));

export const PageNotFoundRouter = () => (
  <Suspense fallback={<Loading />}>
    <PageNotFound />
  </Suspense>
);
